const CRM_API_ORIGIN = 'https://dev-crm.karmad.ir';
const ACTION_API_ORIGIN = 'https://action-api.karmad.ir';

/**
 * در development با setupProxy درخواست‌ها به /api/v1 همان origin می‌روند → بدون OPTIONS preflight.
 * production: REACT_APP_USE_API_PROXY=true + nginx proxy، یا URL کامل cross-origin.
 */
const useApiProxy =
  process.env.REACT_APP_USE_API_PROXY === 'true' ||
  (process.env.REACT_APP_USE_API_PROXY !== 'false' &&
    process.env.NODE_ENV === 'development');

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  (useApiProxy ? '/api/v1' : `${CRM_API_ORIGIN}/api/v1`);

export const ACTION_API_BASE_URL =
  process.env.REACT_APP_ACTION_API_BASE_URL ||
  (useApiProxy ? '/action-api/v1' : `${ACTION_API_ORIGIN}/api/v1`);

// تابع helper برای ساخت URL کامل
export const getApiUrl = (endpoint) => {
  // اگر endpoint با / شروع شود، آن را حذف می‌کنیم
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  // بدون locale در URL
  return `${API_BASE_URL}/${cleanEndpoint}`;
};

// تابع helper برای ساخت query string
export const buildQueryString = (params) => {
  // ✅ تغییر: استفاده از روش دستی به جای URLSearchParams
  // تا کاراکترهای خاص مثل { } بدون encode باقی بمانند
  
  const queryParts = [];
  
  Object.keys(params).forEach(key => {
    const value = params[key];
    if (value !== null && value !== undefined && value !== '') {
      if (Array.isArray(value)) {
        value.forEach(item => {
          queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(item)}`);
        });
      } else {
        // ✅ برای field که شامل { } است، encode نمی‌کنیم
        if (key === 'fields') {
          // فقط کاراکترهای ضروری را encode می‌کنیم (مثل space و &)
          const encodedValue = String(value)
            .replace(/ /g, '%20')
            .replace(/&/g, '%26');
          queryParts.push(`${key}=${encodedValue}`);
        } else if (key === 'filters') {
          // filters: فقط space ها و کاراکترهای خاص را encode می‌کنیم
          const encodedValue = String(value)
            .replace(/ /g, '%20')
            .replace(/"/g, '%22')
            .replace(/&/g, '%26');
          queryParts.push(`${key}=${encodedValue}`);
        } else {
          queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
        }
      }
    }
  });
  
  return queryParts.join('&');
};

// تابع helper برای ساخت URL با query parameters
export const getApiUrlWithParams = (endpoint, params = {}) => {
  const url = getApiUrl(endpoint);
  const queryString = buildQueryString(params);
  
  console.log('🔧 Building URL:', {
    endpoint,
    params,
    baseUrl: url,
    queryString,
    finalUrl: queryString ? `${url}?${queryString}` : url
  });
  
  return queryString ? `${url}?${queryString}` : url;
};

// تابع helper برای ساخت URL کامل ماژول action
export const getActionApiUrl = (endpoint = '') => {
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return cleanEndpoint ? `${ACTION_API_BASE_URL}/${cleanEndpoint}` : ACTION_API_BASE_URL;
};

export default {
  API_BASE_URL,
  ACTION_API_BASE_URL,
  getApiUrl,
  buildQueryString,
  getApiUrlWithParams,
  getActionApiUrl,
};